<rap-rosters-ui [rosters]="rosters$ | async" [rostersCount]="roastersCount$ | async"
  (deleteAnalyticsEmitter)="deleteRoster($event)" (manageStudentEmitter)="manageStudent($event)"
  (searchEmitter)="search($event)"></rap-rosters-ui>